<template>
  <div class="login" @keyup.enter="Login">
    <div class="topBar">
      <userTop :isLogin="true" />
    </div>
    <el-card class="signBox" >
      <el-form
        class="demo-ruleForm"
        v-bind:model="ruleForm"
        status-icon=""
        v-bind:rules="rules"
        ref="form"
        label-width="0px"
      >
        <el-form-item label="" prop="cellphone">
          <span>{{ $t('login.userName') }}</span>
          <el-input
            type="text"
            v-model="ruleForm.cellphone"
            autocomplete="off"
            :placeholder="$t('login.enterName')"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="password">
          <span>{{ $t('login.password') }}</span>
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            :placeholder="$t('login.enterPassword')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="success"
            style="width: 100%; margin-top: 20px"
            @click="Login"
          >
            {{ $t('login.login') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import UserTop from '../components/UserTop.vue'
export default {
  name: 'Login',
  components: {
    userTop: UserTop
  },
  data () {
    const validateCellphone = (rule, value, callback) => {
      if (value) callback()
      else callback(new Error(this.$t('login.enterName') + '!'))
    }

    const validatePassword = (rule, value, callback) => {
      if (value) callback()
      else callback(new Error(this.$t('login.enterPassword') + '!'))
    }

    let cellphone = ''

    return {
      ruleForm: { cellphone, password: '' },
      rules: {
        cellphone: [{ validator: validateCellphone, trigger: 'blur' }],
        password: [{ validator: validatePassword, trigger: 'blur' }]
      }
    }
  },
  methods: {
    getFirstMenuKey (menu) {
      if (menu.child && menu.child.length) {
        return menu.child[0].route
      } else {
        return menu.route
      }
    },
    Login () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let password = this.ruleForm.password
          let ruleForm = { ...this.ruleForm, password }
          let { data } = await window.instance.post(openSurveyReqUrl + 'account/login', ruleForm)

          if (data.code === 200) {
            this.$store.commit('setToken', data.data.token)
            this.$store.commit('setAccount', data.data.cellphone)
            this.$store.commit('setRoleCode', data.data.role)
            this.$store.commit('setAdmin', data.data.role.toUpperCase() === 'ADMIN' || data.data.role.toUpperCase() === 'NIKEINTERNALMM')
            this.$store.commit('setOthers', data.data.role.toUpperCase() === 'OTHERS')
            this.$store.commit('setHead', data.data.role.toUpperCase() === 'HEADQUARTER' || data.data.role.toUpperCase() === 'NIKEINTERNALCLIENT')
            localStorage.setItem('userName', data.data.name)
            localStorage.setItem('account', data.data.account)
            localStorage.setItem('roleCode', data.data.role)
            localStorage.setItem('isAdmin', data.data.role.toUpperCase() === 'ADMIN' || data.data.role.toUpperCase() === 'NIKEINTERNALMM')
            localStorage.setItem('isOthers', data.data.role.toUpperCase() === 'OTHERS')
            localStorage.setItem('isHead', data.data.role.toUpperCase() === 'HEADQUARTER' || data.data.role.toUpperCase() === 'NIKEINTERNALCLIENT')
          }
          if (data.code !== 200) {
            this.$message.warning(data.message)
            return false
          }
          /* if (!data.data.menus || !data.data.menus.length) {
            this.$message.error(this.$t('login.noMenu'))
            return false
          } */

          /*
          菜单相关的暂时不要
          const indexMenu = this.getFirstMenuKey(data.data.menus[0])
          localStorage.cellphone = ruleForm.cellphone
          // localStorage.remember = this.remember || false;
          const { statementNational, statementRegion, statementCity, statementSingleStore } = data.data.rolePermission
          const isSecond = !statementNational && statementRegion // 是二级页面
          const isThird = (!statementRegion && statementCity) // 是三级页面
          const isFourth = (!statementCity && statementSingleStore) // 是四级页面
          console.log('getFirstMenuKey', indexMenu)
          Cookies.set('menuTitle', indexMenu)
          const menus = data.data.menus
          const initDate = this.$tool.getCurrentMonth()
          let startTime = initDate.startTime
          let endTime = initDate.endTime
          const dateQueries = '&dateType=month&startTime=' + startTime + '&endTime=' + endTime
          if (isSecond) {
            menus[0].route = menus[0].route + '?isSecond=true&regionNo=' + data.data.regionNo + '&regionName=' + data.data.regionName + dateQueries
          }
          if (isThird) {
            menus[0].route = menus[0].route + '?isThird=true&regionNo=' + data.data.regionNo + '&regionName=' + data.data.regionName + '&cityNo=' + data.data.cityNo + '&cityName=' + data.data.cityName + dateQueries
          }
          if (isFourth) {
            menus[0].route = menus[0].route + '?posId=' + data.data.posId + '&doorName=' + data.data.doorName + dateQueries
          }
          localStorage.setItem('surveyMenuData', JSON.stringify(menus))
          */
          this.$router.push('/openSurvey/newSurvey')
          Cookies.set('menuTitle','/newSurvey?published=1')
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="sass">
.login
  height: 100vh
  width: 100vw
  background: #EEEEEE
  overflow: hidden
  .topBar
    display: flex
    height: 40px
    padding: 15px
    align-items: center
    flex-direction: row-reverse
  .signBox
    width: 360px
    padding: 20px
    position: absolute
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px

</style>



// WEBPACK FOOTER //
// src/openSurvey/pages/Login.vue